import { StylesDerivedNativeActionNames } from '@wix/editor-platform-host-integration-apis';
import { GlobalDesignAction } from '../../types';
import defaultStyleActionValidator from '../actionValidators/default';
import defaultStrategy from '../manifestProcessingStrategies/default';

const createDefaultActionDefinition: (
  name: StylesDerivedNativeActionNames,
) => GlobalDesignAction = (name: StylesDerivedNativeActionNames) => {
  return {
    validator: defaultStyleActionValidator(name),
    manifestProcessor: defaultStrategy,
  };
};

export default createDefaultActionDefinition;
